import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=5b129a2c&scoped=true&"
import script from "./SiteNav.vue?vue&type=script&lang=js&"
export * from "./SiteNav.vue?vue&type=script&lang=js&"
import style0 from "./SiteNav.vue?vue&type=style&index=0&id=5b129a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b129a2c",
  null
  
)

export default component.exports